import { Component, OnInit } from '@angular/core';
// import { AppContentsService } from '../../../services/app-contents.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
//    private appContents: AppContents;
//    title = '';
//    subtitle = '';

    ngOnInit(): void {
//        this.appContentsService.getAppContents()
//            .subscribe(
//                response => {
//                    this.appContents = response;
//                    this.title = this.appContents.title;
//                    this.subtitle = this.appContents.subtitle;
//                },
//                err => console.error(err)
//            );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/ui/header/header.component.ts